/* eslint-disable jsx-a11y/no-onchange */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ArrowBackIosNewOutlined, InfoOutlined, PersonOutlineOutlined } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Divider,
    Grid,
    IconButton,
    Stack,
    Typography,
    useTheme,
} from '@mui/material';
import deliverImg from '../../../assets/delivery-icon.svg';
import invoiceIcon from '../../../assets/invoice-w.png';
import { addItemToCart } from '../api/addToCart';
import { getCart } from '../api/getCart';
import { getLocationCategoriesWithProducts } from '../api/getCategories';
import { getMenuByLocation } from '../api/getMenu';
import { getProduct } from '../api/getProduct';
import { applyPromoCode } from '../api/promoCode';
import { Category, Product } from '../type';
import { handleDateFormat, handleOnError } from '@/utils/commonHelperFunc';
import { axios } from '@/lib/axios';
import { svgPaths } from '@/components/Layout/SvgPaths';
import Delete from '@/components/Icons/Delete';
import { Button, Spinner } from '@/components/Elements';

const NewOrder1 = ({
    closeDialog,
    isOrder,
    userData,
    selectedUserAction,
    setNewOrder,
    selectedSlot,
    orderForUser,
}: any) => {
    const theme = useTheme();
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [qyt, setQyt] = useState(1);
    const promiseTime = selectedSlot?.date + ' ' + selectedSlot?.time;
    const [amount, setAmount] = useState(0);
    const [searchVal, setSearchVal] = useState<string>('');
    const [categories, setCategories] = useState<Category[]>([]);
    const [products, setProducts] = useState<Product[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<Product | null | any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isAddToCartLoading, setIsAddToCartLoading] = useState<boolean>(false);
    const [isActive, setIsActive] = useState<string>('');
    const [cartList, setCartList] = useState<Product[]>([]);
    const [cartCharges, setCartCharges] = useState<{ delivery_fee: number; tax: number }>({});
    const [cartId, setCartId] = useState<null>(null);
    // const [instructions, setInstructions] = useState<boolean>(false);
    // const [timeSlots, setTimeSlots] = useState<string[]>([]);
    // const [promiseTime, setPromiseTime] = useState<string | boolean>(false);
    const [storeinfo, setStoreinfo] = useState<any>();
    const [menuData, setMenuData] = useState<any>([]);
    const [isDiscount, setIsDiscount] = useState<boolean>(false);
    const [promoCode, setPromoCode] = useState<string>('');
    const [promoCodeResponse, setPromoCodeResponse] = useState<any>({
        data: {},
        message: '',
    });

    const getLocationDetails = async () => {
        const store = await axios.get(`/v1/get-location-by-id/${isOrder.store}`);
        setStoreinfo(store.data);
    };
    const getMenuByLocationData = async () => {
        try {
            await getMenuByLocation(isOrder.store, () => setNewOrder(false)).then((res) => {
                setMenuData(res);
            });
        } catch (e) {
            console.log('error in get menu by location -->', e);
        }
    };

    useEffect(() => {
        getMenuByLocationData();
        setIsLoading(true);
        getLocationDetails();
        const date = new Date();
        isOrder.order_type_id === '18'
            ? getLocationCategoriesWithProducts(isOrder.store).then((list) => {
                  setCategories(list);
                  setIsActive(list[0].category_name);
                  setProducts(list[0].products);
              })
            : getLocationCategoriesWithProducts(isOrder.store).then((list) => {
                  setCategories(list);
                  setIsActive(list[0].category_name);
                  // here
                  //   getMenuByLocation(isOrder.store).then((list) => {
                  //       setProducts(list);
                  //   });
                  setProducts(list[0].products);
                  //   getProductsWithCategory(list[0].id).then((list) => {
                  //       setProducts(list);
                  //   });
              });
        // getPromiseTime(
        //     isOrder.store,
        //     isOrder.order_type_id,
        //     moment(date).format('YYYY-MM-DD')
        // ).then((e) => {
        //     const filteredTimeSlots = e?.filter((time: any) => moment().isBefore(time));
        //     setTimeSlots(filteredTimeSlots);
        // });
        setIsLoading(false);
    }, []);

    if (isLoading) {
        return (
            <div className="w-full h-48 flex justify-center items-center bg-white">
                <Spinner size="lg" />
            </div>
        );
    }
    const handleCategoryChange = (category: any) => {
        setProducts([]);
        setIsLoading(true);
        setIsActive(category.category_name);
        isOrder.order_type_id === '18'
            ? setProducts(category.products)
            : getLocationCategoriesWithProducts(isOrder.store).then((list) => {
                  //   setProducts(list[0]?.products);
                  const filteredArr = list?.filter((item: any) => item?.id === category?.id);

                  // here
                  //   getMenuByLocation(isOrder.store).then((list) => {
                  //       setProducts(list);
                  //   });
                  setProducts(filteredArr[0].products);
              });
        setIsLoading(false);
    };

    const filteredProducts = products?.filter((product) => {
        return product?.product_name?.toLowerCase()?.includes(searchVal.toLowerCase());
    });
    const filteredCategories = categories?.filter((category) =>
        category.category_name === 'Hero' || category.category_name === 'Recommended'
            ? null
            : category
    );

    const deepCopy = (obj: any) => {
        if (typeof obj !== 'object' || obj === null) {
            return obj; // Return non-objects as is
        }

        if (Array.isArray(obj)) {
            // If the object is an array, create a deep copy of each element
            return obj.map((item) => deepCopy(item));
        }

        // If the object is a plain object, create a deep copy of each property
        const copy: any = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                copy[key] = deepCopy(obj[key]);
            }
        }

        return copy;
    };

    const addToCart = async () => {
        try {
            setIsAddToCartLoading(true);
            let isModifierValid: any = true;
            const menu_item_modifiers = [];
            let tempSelectedProduct = deepCopy(selectedProduct);
            if (tempSelectedProduct.modifiers && tempSelectedProduct.modifiers.length > 0) {
                _.forEach(tempSelectedProduct.modifiers, function (modifier) {
                    const selectedOptions: any = [];
                    let selectedCount = 0;
                    let quantity = 0;
                    _.forEach(modifier.options, function (options) {
                        if (options.selected) {
                            selectedCount += 1;
                            quantity += 1;
                            selectedOptions.push(options);
                        } else if (options.quantity) {
                            quantity += 1;
                            selectedOptions.push(options);
                        }
                    });
                    if (selectedOptions.length > 0) {
                        modifier.options = selectedOptions;
                        menu_item_modifiers.push(modifier);
                    }
                    if (totalQuantity == 0) {
                        if (selectedCount < modifier.select_min && modifier.is_required == 1) {
                            isModifierValid = `${modifier.modification_text} required`;
                            return false;
                        }
                    } else {
                        if (totalQuantity < modifier.select_min && modifier.is_required == 1) {
                            isModifierValid = `${modifier.modification_text} required`;
                            return false;
                        }
                    }
                    if (modifier.is_required == 1) {
                        if (
                            !modifier.options?.reduce(
                                (acc: any, curr: any) => curr?.modifier_qyt + acc,
                                0
                            ) ||
                            modifier.options?.reduce(
                                (acc: any, curr: any) => curr?.modifier_qyt + acc,
                                0
                            ) < modifier.select_min
                        ) {
                            isModifierValid = `${modifier.modification_text} required`;
                            return false;
                        }
                    }
                });
            }
            if (isModifierValid === true) {
                const {
                    id,
                    menu_item_quantity,
                    menu_item_instructions,
                    modifiers,
                    product_type_id,
                    ...remain
                } = tempSelectedProduct;
                const selectedMenuData = menuData?.find(
                    (el: any) => el?.category_name === isActive
                );
                let modifierData = [];
                let filteredModifierData = [];
                if (tempSelectedProduct?.modifiers?.length > 0) {
                    const tempData = deepCopy(tempSelectedProduct);
                    const temp = tempData?.modifiers;
                    // modifierData = temp.map((item: any) => {
                    //     return !item?.options ? { ...item, options: [] } : item;
                    // });
                    // modifierData = temp.map((item: any) => {
                    //     // delete item.date_created;
                    //     // delete item.date_updated;
                    //     item.options.map((option: any) => {
                    //         // delete option.date_created;
                    //         // delete option.date_updated;
                    //         // delete option.selected;
                    //         return option.option_image ? delete option.option_image : option;
                    //         // console.log(option.option_image);
                    //     });
                    // });
                    modifierData = temp.map((item: any) => {
                        // Create a new object without the properties you want to delete
                        const newItem = deepCopy(item);
                        delete newItem.date_created;
                        delete newItem.date_updated;

                        // If the 'options' array exists, process it
                        if (newItem.options) {
                            newItem.options = newItem.options
                                .map((option: any) => {
                                    // Create a new object without the properties you want to delete
                                    const newOption = deepCopy(option);

                                    // Conditionally remove the specified properties
                                    if (newOption.modifier_qyt >= 0) {
                                        delete newOption.option_image;
                                        delete newOption.selected;
                                        delete newOption.date_created;
                                        delete newOption.date_updated;

                                        // Return the modified option object
                                        return newOption;
                                    } else {
                                        // Return null for options that don't meet the condition
                                        return null;
                                    }
                                })
                                .filter(Boolean); // Remove undefined/null elements from the array
                        }

                        // Return the modified item object
                        return newItem;
                    });

                    filteredModifierData = modifierData?.filter(
                        (el: any) => el?.options?.length > 0
                    );
                }
                // cartList.find((item: any) => item?.id === selectedProduct?.id)
                //     ? null
                //     : (
                await addItemToCart(
                    {
                        location_id: parseInt(isOrder.store),
                        order_type_id: isOrder.order_type_id,
                        mode_id: 1,
                        promised_time: selectedSlot?.date + ' ' + selectedSlot?.time,
                        menu_id: tempSelectedProduct?.menu_id,
                        menu_item_quantity,
                        menu_item_instructions,
                        user_id: userData?.id,
                        is_deferred: true,
                        //   menu_item_person:
                        //       userData.first_name != null
                        //           ? userData.first_name + ' ' + userData.last_name
                        //           : userData.corporate_name,
                        //   corporate_id: userData.corporate_name != null ? userData.id : 0,
                        ...(!orderForUser && { corporate_id: userData?.user_corporate_id }),
                        ...(tempSelectedProduct?.modifiers?.length > 0 && {
                            menu_item_modifiers: filteredModifierData,
                        }),
                    },
                    cartId
                )
                    .then(async (res) => {
                        setCartList([...cartList, tempSelectedProduct]);
                        setCartId(res);
                        if (isOrder?.order_type_id == '18') {
                            //   const deferredCartRes: any = await getDeferredCart();
                            //   const currentCartData: any = deferredCartRes?.find(
                            //       (el: any) => el?.id === res
                            //   );

                            getCart(res, true, isOrder?.lat, isOrder?.long).then((e) => {
                                setCartCharges(e?.charges);
                            });
                        } else {
                            getCart(res).then((e) => {
                                setCartCharges(e?.charges);
                            });
                        }
                    })
                    .catch((err) => console.log(err.message)),
                    //   );
                    setTotalQuantity(0);
                setSelectedProduct(false);
                tempSelectedProduct = false;
            } else {
                alert(isModifierValid);
            }
        } catch (err) {
            console.log('error from addToCart', err);
        } finally {
            setIsAddToCartLoading(false);
        }
    };

    const handleSelected = (product: any) => {
        const selectedMenuGroup = menuData?.find((el: any) => el?.category_name === isActive);

        //   getProduct(product.id, selectedMenuGroup?.menu_group_id).then((res) => {
        getProduct(product.id, product.menu_group_id).then((res) => {
            setSelectedProduct({ ...res, menu_item_quantity: 1, menu_id: product?.menu_id });
        });
    };

    const removeProduct = (id: any) => {
        setCartList(cartList.filter((product) => product.id !== id));
    };
    const handlePromoCodeSubmit = async () => {
        try {
            const params = {
                coupon: promoCode,
                cart_group_id: cartId,
                subtotal: cartList?.reduce((acc, curr) => acc + curr?.price, 0),
                delivery_fee: cartCharges?.delivery_fee,
            };
            await applyPromoCode(params)
                .then((res) => {
                    if (res?.success) {
                        setPromoCodeResponse({
                            message: 'Coupon Code applied successfully.',
                            data: res?.data,
                        });
                    }
                })
                .catch((err) => setPromoCodeResponse({ message: err?.response?.data?.message }));
        } catch (error) {
            console.log('error from handle promo code submit->>', error);
        }
    };

    const getFinalPrice = () => {
        return (
            (cartList?.reduce(
                (acc, curr: any) =>
                    acc +
                    (curr?.price +
                        (curr?.modifiers
                            ? curr?.modifiers?.reduce(
                                  (modAcc: any, modCurr: any) =>
                                      modAcc +
                                      modCurr?.options?.reduce(
                                          (optAcc: any, optCurr: any) =>
                                              optAcc +
                                              (optCurr?.selected
                                                  ? optCurr?.option_price
                                                      ? optCurr?.option_price
                                                      : 0
                                                  : 0),
                                          0
                                      ),
                                  0
                              )
                            : 0)) *
                        curr?.menu_item_quantity,
                0
            ) +
                Number(promoCodeResponse?.data?.valid ? promoCodeResponse?.data?.discount : -0)) /
                100 +
            cartCharges?.delivery_fee / 100 +
            (cartList?.reduce(
                (acc, curr: any) =>
                    acc +
                    (curr?.price +
                        (curr?.modifiers
                            ? curr?.modifiers?.reduce(
                                  (modAcc: any, modCurr: any) =>
                                      modAcc +
                                      modCurr?.options?.reduce(
                                          (optAcc: any, optCurr: any) =>
                                              optAcc +
                                              (optCurr?.selected
                                                  ? optCurr?.option_price
                                                      ? optCurr?.option_price
                                                      : 0
                                                  : 0),
                                          0
                                      ),
                                  0
                              )
                            : 0)) *
                        curr?.menu_item_quantity,
                0
            ) *
                cartCharges?.tax) /
                100 /
                100
        ).toFixed(2);
    };

    const getTaxAmount = () => {
        return (
            (cartList?.reduce(
                (acc, curr: any) =>
                    acc +
                    (curr?.price +
                        (curr?.modifiers
                            ? curr?.modifiers?.reduce(
                                  (modAcc: any, modCurr: any) =>
                                      modAcc +
                                      modCurr?.options?.reduce(
                                          (optAcc: any, optCurr: any) =>
                                              optAcc +
                                              (optCurr?.selected
                                                  ? optCurr?.option_price
                                                      ? optCurr?.option_price
                                                      : 0
                                                  : 0),
                                          0
                                      ),
                                  0
                              )
                            : 0)) *
                        curr?.menu_item_quantity,
                0
            ) *
                cartCharges?.tax) /
            100 /
            100
        ).toFixed(2);
    };

    const getSubTotal = () => {
        return (
            cartList?.reduce(
                (acc, curr: any) =>
                    acc +
                    (curr?.price +
                        (curr?.modifiers
                            ? curr?.modifiers?.reduce(
                                  (modAcc: any, modCurr: any) =>
                                      modAcc +
                                      modCurr?.options?.reduce(
                                          (optAcc: any, optCurr: any) =>
                                              optAcc +
                                              (optCurr?.selected
                                                  ? optCurr?.option_price
                                                      ? optCurr?.option_price
                                                      : 0
                                                  : 0),
                                          0
                                      ),
                                  0
                              )
                            : 0)) *
                        curr?.menu_item_quantity,
                0
            ) / 100
        ).toFixed(2);
    };

    const selectOptions = (
        modifierIndex: number,
        optionIndex: number,
        isSelect: boolean,
        quantity?: number
    ) => {
        // const details = JSON.parse(JSON.stringify(selectedProduct));
        const details = deepCopy(selectedProduct);
        const modifier = details.modifiers[modifierIndex];
        const selectedCount = modifier.options.filter(
            (item: any) => item.selected != undefined && item.selected
        );
        const max = modifier.select_max;
        if (quantity == null) {
            if (modifier.options[optionIndex].selected == undefined) {
                if (selectedCount.length < max) {
                    Object.assign(details.modifiers[modifierIndex].options[optionIndex], {
                        selected: true,
                        modifier_qyt: 0,
                    });
                    const price =
                        details.modifiers[modifierIndex].options[optionIndex].option_price;
                    if (price != undefined) {
                        setAmount(amount + price * qyt);
                    }
                } else {
                    // addNotification({
                    //     type: 'error',
                    //     title: `You can select only ${max} items`,
                    // });
                    alert(`You can select only ${max} items`);
                }
            } else {
                if (isSelect) {
                    if (selectedCount.length < max) {
                        Object.assign(details.modifiers[modifierIndex].options[optionIndex], {
                            selected: isSelect,
                        });
                        const price =
                            details.modifiers[modifierIndex].options[optionIndex].option_price;
                        if (price != undefined) {
                            setAmount(amount + price * qyt);
                        }
                    } else {
                        // addNotification({
                        //     type: 'error',
                        //     title: `You can select only ${max} items`,
                        // });
                        alert(`You can select only ${max} items`);
                    }
                } else {
                    Object.assign(details.modifiers[modifierIndex].options[optionIndex], {
                        selected: isSelect,
                    });
                    const price =
                        details.modifiers[modifierIndex].options[optionIndex].option_price;
                    if (price != undefined) {
                        setAmount(amount - price * qyt);
                    }
                }
            }
        } else {
            const total =
                details.modifiers[modifierIndex].options[optionIndex].modifier_qyt == undefined
                    ? 0
                    : details.modifiers[modifierIndex].options[optionIndex].modifier_qyt;
            let totalAll = 0;
            details.modifiers[modifierIndex].options.map((item: any) => {
                totalAll = item.modifier_qyt ? item.modifier_qyt + totalAll : totalAll;
            });
            // let totalNumOfModi = 0;
            // let totalMaxRequired = 0;
            // details.modifiers.map((item)=>{
            //     if(item.is_required == 1){
            //       totalNumOfModi = totalNumOfModi+1
            //       totalMaxRequired = totalMaxRequired+ item.select_max
            //     }
            // })
            // let data = totalNumOfModi > 1 ? totalMaxRequired : totalQuantity;
            if (totalAll < max || total > quantity) {
                if (quantity < 0) {
                    // addNotification({
                    //     type: 'error',
                    //     title: `You can't select less than 0  items`,
                    // });
                    alert(`You can't select less than 0  items`);
                } else {
                    setTotalQuantity(
                        totalQuantity +
                            quantity -
                            (details.modifiers[modifierIndex].options[optionIndex]?.modifier_qyt !=
                            null
                                ? details.modifiers[modifierIndex].options[optionIndex]
                                      ?.modifier_qyt
                                : 0)
                    );
                    Object.assign(details.modifiers[modifierIndex].options[optionIndex], {
                        selected: true,
                        modifier_qyt: quantity,
                    });

                    const price =
                        details.modifiers[modifierIndex].options[optionIndex].option_price;
                    if (price != undefined) {
                        setAmount(amount + price * qyt);
                    }
                }
            } else {
                // addNotification({
                //     type: 'error',
                //     title: `You can select only ${max} items`,
                // });

                alert(`You can select only ${max} items`);
            }
        }

        setSelectedProduct(details);
    };

    return storeinfo == null ? (
        <>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="h-full w-full flex items-center justify-center">
                        <Spinner size="xl" />
                    </div>
                </div>
            </div>
        </>
    ) : (
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="neworder2ModalLabel">
                    New Order
                    {/*#224589*/}
                </h5>
                <button type="button" className="btn-close" onClick={() => closeDialog()}></button>
            </div>
            <div className="modal-body">
                <div className="info-header location-edit pt-0 mb-0">
                    <div className="left-info">
                        <p className="d-flex">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={svgPaths['Locations'].width}
                                height={svgPaths['Locations'].height}
                                viewBox={svgPaths['Locations'].viewBox}
                                fill="none"
                            >
                                <path d={svgPaths['Locations'].path} fill="#526EFF" />
                            </svg>
                            <strong>{storeinfo.location_name}</strong> /{' '}
                            {storeinfo.location_address_1}, {storeinfo.location_city},{' '}
                            {storeinfo.location_state} {storeinfo.location_zip}
                        </p>
                    </div>
                    <div className="right-info">
                        <div className="order-left-head">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="flexRadioDefault"
                                    id="flexRadioDefault1"
                                    defaultChecked={isOrder.order_type_id === '17'}
                                    disabled
                                />
                                <label className="form-check-label" htmlFor="flexRadioDefault1">
                                    Pickup
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="flexRadioDefault"
                                    id="flexRadioDefault2"
                                    defaultChecked={isOrder.order_type_id === '18'}
                                    disabled
                                />
                                <label className="form-check-label" htmlFor="flexRadioDefault2">
                                    Delivery
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row new-order1">
                    <div className="col-12 col-md-8 new-order-leftcol">
                        <div className="accordion accordion-flush" id="accordionorder">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="flush-headingOne">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseOne"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseOne"
                                    >
                                        <p className="box-cookie-tx">
                                            <span>
                                                <PersonOutlineOutlined className="pColor" />
                                                <strong>
                                                    {userData?.corporate_active &&
                                                        userData.corporate_name}
                                                    {!userData?.corporate_active &&
                                                        userData.first_name +
                                                            ' ' +
                                                            userData.last_name}
                                                </strong>
                                            </span>
                                        </p>
                                    </button>
                                </h2>
                                <div
                                    id="flush-collapseOne"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingOne"
                                    data-bs-parent="#accordionorder"
                                >
                                    <div className="accordion-body">
                                        <div className="jacob-info">
                                            <ul className="corporation-list">
                                                <li>
                                                    <strong>
                                                        <svg
                                                            width="20"
                                                            height="16"
                                                            viewBox="0 0 20 16"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M3.33203 3.83333C3.33203 4.4926 3.52753 5.13707 3.8938 5.68523C4.26007 6.2334 4.78067 6.66064 5.38975 6.91293C5.99884 7.16522 6.66906 7.23124 7.31567 7.10262C7.96227 6.974 8.55621 6.65653 9.02239 6.19036C9.48856 5.72418 9.80603 5.13024 9.93465 4.48363C10.0633 3.83703 9.99726 3.16681 9.74496 2.55772C9.49267 1.94863 9.06543 1.42804 8.51727 1.06177C7.9691 0.695497 7.32464 0.5 6.66536 0.5C5.78131 0.5 4.93346 0.851189 4.30834 1.47631C3.68322 2.10143 3.33203 2.94928 3.33203 3.83333ZM8.33203 3.83333C8.33203 4.16297 8.23428 4.4852 8.05115 4.75928C7.86801 5.03337 7.60771 5.24699 7.30317 5.37313C6.99863 5.49928 6.66352 5.53228 6.34021 5.46798C6.01691 5.40367 5.71994 5.24493 5.48685 5.01184C5.25377 4.77876 5.09503 4.48179 5.03072 4.15848C4.96641 3.83518 4.99942 3.50007 5.12557 3.19553C5.25171 2.89098 5.46533 2.63069 5.73941 2.44755C6.0135 2.26442 6.33573 2.16667 6.66536 2.16667C7.10739 2.16667 7.53132 2.34226 7.84388 2.65482C8.15644 2.96738 8.33203 3.39131 8.33203 3.83333ZM1.66536 15.5H11.6654C11.8864 15.5 12.0983 15.4122 12.2546 15.2559C12.4109 15.0996 12.4987 14.8877 12.4987 14.6667V12.1667C12.4987 11.2826 12.1475 10.4348 11.5224 9.80964C10.8973 9.18452 10.0494 8.83333 9.16537 8.83333H4.16536C3.28131 8.83333 2.43346 9.18452 1.80834 9.80964C1.18322 10.4348 0.832031 11.2826 0.832031 12.1667V14.6667C0.832031 14.8877 0.919829 15.0996 1.07611 15.2559C1.23239 15.4122 1.44435 15.5 1.66536 15.5ZM2.4987 12.1667C2.4987 11.7246 2.67429 11.3007 2.98685 10.9882C3.29941 10.6756 3.72334 10.5 4.16536 10.5H9.16537C9.60739 10.5 10.0313 10.6756 10.3439 10.9882C10.6564 11.3007 10.832 11.7246 10.832 12.1667V13.8333H2.4987V12.1667ZM19.1654 1.33333C19.1654 1.55435 19.0776 1.76631 18.9213 1.92259C18.765 2.07887 18.553 2.16667 18.332 2.16667H13.332C13.111 2.16667 12.8991 2.07887 12.7428 1.92259C12.5865 1.76631 12.4987 1.55435 12.4987 1.33333C12.4987 1.11232 12.5865 0.900358 12.7428 0.744078C12.8991 0.587797 13.111 0.5 13.332 0.5H18.332C18.553 0.5 18.765 0.587797 18.9213 0.744078C19.0776 0.900358 19.1654 1.11232 19.1654 1.33333ZM19.1654 4.66667C19.1654 4.88768 19.0776 5.09964 18.9213 5.25592C18.765 5.4122 18.553 5.5 18.332 5.5H13.332C13.111 5.5 12.8991 5.4122 12.7428 5.25592C12.5865 5.09964 12.4987 4.88768 12.4987 4.66667C12.4987 4.44565 12.5865 4.23369 12.7428 4.07741C12.8991 3.92113 13.111 3.83333 13.332 3.83333H18.332C18.553 3.83333 18.765 3.92113 18.9213 4.07741C19.0776 4.23369 19.1654 4.44565 19.1654 4.66667ZM19.1654 8C19.1654 8.22101 19.0776 8.43297 18.9213 8.58926C18.765 8.74554 18.553 8.83333 18.332 8.83333H13.332C13.111 8.83333 12.8991 8.74554 12.7428 8.58926C12.5865 8.43297 12.4987 8.22101 12.4987 8C12.4987 7.77899 12.5865 7.56702 12.7428 7.41074C12.8991 7.25446 13.111 7.16667 13.332 7.16667H18.332C18.553 7.16667 18.765 7.25446 18.9213 7.41074C19.0776 7.56702 19.1654 7.77899 19.1654 8Z"
                                                                fill="#A3BED9"
                                                            />
                                                        </svg>
                                                        Information
                                                    </strong>
                                                </li>
                                                {userData.user_birthday ? (
                                                    <>
                                                        <li>
                                                            <strong>Birthday: </strong>
                                                            <span>
                                                                {handleDateFormat(
                                                                    userData.user_birthday
                                                                ) || '-'}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <strong>Company: </strong>
                                                            <span>
                                                                {userData?.corporate_active
                                                                    ? userData.user_company
                                                                    : '-'}
                                                            </span>
                                                        </li>
                                                    </>
                                                ) : null}
                                                <li>
                                                    <strong>Email: </strong>
                                                    <span>
                                                        {userData?.corporate_active
                                                            ? userData.corporate_email
                                                            : userData.user_email
                                                            ? userData.user_email
                                                            : '-'}
                                                    </span>
                                                </li>
                                                <li>
                                                    <strong>Phone: </strong>
                                                    <span>
                                                        {userData?.corporate_active
                                                            ? userData.corporate_phone
                                                            : userData.user_phone
                                                            ? userData.user_phone
                                                            : '-'}
                                                    </span>
                                                </li>
                                                <li>
                                                    <strong>Created: </strong>
                                                    <span>
                                                        {handleDateFormat(
                                                            userData.corporate_creation_date
                                                        ) ||
                                                            handleDateFormat(
                                                                userData.user_creation_date
                                                            ) ||
                                                            '-'}
                                                    </span>
                                                </li>
                                            </ul>
                                            {isOrder.address ? (
                                                <ul className="corporation-list">
                                                    <li>
                                                        <strong>
                                                            <img
                                                                src={deliverImg}
                                                                alt="deliverImg"
                                                            />
                                                            Delivery Address
                                                        </strong>
                                                    </li>
                                                    <li>
                                                        <span>{isOrder.address}</span>
                                                    </li>
                                                </ul>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="order-new-search pb-4 pt-4 d-flex justify-content-between align-items-center">
                            <p className="mb-0">
                                <strong>Products</strong>
                            </p>
                            <div
                                className="input-group search make-search"
                                style={{ width: 'max-content' }}
                            >
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search"
                                    style={{ margin: '0 !important' }}
                                    value={searchVal}
                                    onChange={(e) => setSearchVal(e.target.value)}
                                />
                                <div className="input-group-append">
                                    <span className="input-group-text">
                                        <i className="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="order-list-tabs">
                            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                {filteredCategories?.map((category) => {
                                    const { id, category_name } = category;
                                    return (
                                        <li key={id} className="nav-item" role="presentation">
                                            <button
                                                className={`nav-link ${
                                                    isActive === category_name && 'active'
                                                }`}
                                                type="button"
                                                role="tab"
                                                onClick={() =>
                                                    isActive !== category_name
                                                        ? handleCategoryChange(category)
                                                        : null
                                                }
                                            >
                                                {category_name}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div
                                    className="tab-pane fade show active"
                                    id="pills-cookie"
                                    role="tabpanel"
                                    aria-labelledby="pills-cookie-tab"
                                >
                                    <div className="row">
                                        {selectedProduct ? (
                                            <div
                                                className="tab-pane fade show active"
                                                id="pills-cookie"
                                                role="tabpanel"
                                                aria-labelledby="pills-cookie-tab"
                                            >
                                                <div className="row choose-back align-items-center">
                                                    <div className="col-12 col-md-5">
                                                        <div
                                                            className="back-btn d-flex align-items-center"
                                                            onClick={() => setSelectedProduct(null)}
                                                        >
                                                            <a className="back-anc" href="#">
                                                                <div className="back-bt">
                                                                    <ArrowBackIosNewOutlined />
                                                                </div>
                                                            </a>
                                                            <span style={{ marginLeft: '10px' }}>
                                                                Back
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-7">
                                                        <div className="order-increment d-flex align-items-center justify-content-end">
                                                            <div className="inrement-lft d-flex align-items-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn add-order"
                                                                    onClick={() => {
                                                                        selectedProduct.menu_item_quantity >
                                                                        1
                                                                            ? setSelectedProduct({
                                                                                  ...selectedProduct,
                                                                                  menu_item_quantity:
                                                                                      selectedProduct.menu_item_quantity -
                                                                                      1,
                                                                              })
                                                                            : null;
                                                                    }}
                                                                >
                                                                    -
                                                                </button>
                                                                <p className="mb-0">
                                                                    {
                                                                        selectedProduct.menu_item_quantity
                                                                    }
                                                                </p>
                                                                <button
                                                                    type="button"
                                                                    className="btn add-order"
                                                                    onClick={() => {
                                                                        setSelectedProduct({
                                                                            ...selectedProduct,
                                                                            menu_item_quantity:
                                                                                selectedProduct.menu_item_quantity +
                                                                                1,
                                                                        });
                                                                    }}
                                                                >
                                                                    +
                                                                </button>
                                                            </div>

                                                            <div className="add-order">
                                                                <button
                                                                    type="button"
                                                                    className="btn add-icon-btn"
                                                                    onClick={() => addToCart()}
                                                                >
                                                                    Add To Order
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row choose-cookie">
                                                    <div className="col-12 col-md-6">
                                                        <div className="new-ordr d-flex align-items-center">
                                                            <div className="ordr-icn">
                                                                <img
                                                                    src={
                                                                        selectedProduct.product_image
                                                                    }
                                                                    alt="pImg"
                                                                    onError={handleOnError}
                                                                />
                                                            </div>
                                                            <div className="order-details">
                                                                <p className="mb-0">
                                                                    <strong>
                                                                        {
                                                                            selectedProduct.product_name
                                                                        }
                                                                    </strong>
                                                                </p>
                                                                <p className="mb-0 dark-tx">
                                                                    $
                                                                    {(
                                                                        selectedProduct.price / 100
                                                                    ).toFixed(2)}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        {/* <p className="text-right mb-0">
                                                            Choose 6 cookies /
                                                            <strong>3 Left</strong>
                                                        </p> */}
                                                        <p className=" text-right mb-0">
                                                            <strong>
                                                                {
                                                                    selectedProduct.product_description
                                                                }
                                                            </strong>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    {/* {selectedProduct?.modifiers?.map(
                                                        ({ id, modification_text }: any) => (
                                                            <div
                                                                className="col-12 col-md-6"
                                                                key={id}
                                                            >
                                                                <div className="product-check-box">
                                                                    <div className="pr-left-ic">
                                                                        <label
                                                                            htmlFor={`modifiers${id}`}
                                                                            className="flex"
                                                                            style={{
                                                                                margin: '0',
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    selectedProduct.product_image
                                                                                }
                                                                                alt="pImg"
                                                                                onError={
                                                                                    handleOnError
                                                                                }
                                                                            />
                                                                            {modification_text}
                                                                        </label>
                                                                    </div>
                                                                    <div className="pr-right-ic">
                                                                        <div className="checkboxes">
                                                                            <div className="all-bx">
                                                                                <label
                                                                                    className="checkbox"
                                                                                    style={{
                                                                                        margin: '0',
                                                                                    }}
                                                                                >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`modifiers${id}`}
                                                                                        name={`modifiers${id}`}
                                                                                        value={`modifiers${id}`}
                                                                                    />
                                                                                    <span></span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    )} */}
                                                    {/* from here */}
                                                    <Stack>
                                                        <Box
                                                        // sx={{
                                                        //     background: '#FFFF',
                                                        //     padding: '15px 20px',
                                                        //     borderRadius: '16px',
                                                        //     boxShadow:
                                                        //         '0px 8px 30px rgba(141, 31, 36, 0.12)',
                                                        // }}
                                                        >
                                                            <Grid container>
                                                                {selectedProduct?.modifiers?.map(
                                                                    (modifier: any, i: number) => {
                                                                        return (
                                                                            <Grid
                                                                                key={i}
                                                                                item
                                                                                lg={12}
                                                                                mt={i == 0 ? 2 : 0}
                                                                            >
                                                                                <Divider
                                                                                    sx={{
                                                                                        border: '1px dashed #D9D9D9',
                                                                                    }}
                                                                                    variant="fullWidth"
                                                                                />
                                                                                <Accordion
                                                                                    sx={{
                                                                                        border: 0,
                                                                                        boxShadow:
                                                                                            'none',
                                                                                        width: '100%',
                                                                                        bgcolor:
                                                                                            'red',
                                                                                    }}
                                                                                    style={{
                                                                                        minWidth:
                                                                                            '100%',
                                                                                    }}
                                                                                >
                                                                                    <AccordionSummary
                                                                                        sx={{
                                                                                            padding:
                                                                                                '0px',
                                                                                            width: '100%',
                                                                                        }}
                                                                                        style={{
                                                                                            minWidth:
                                                                                                '100%',
                                                                                        }}
                                                                                        expandIcon={
                                                                                            <IconButton
                                                                                                sx={{
                                                                                                    width: '40px',
                                                                                                    height: '40px',
                                                                                                    borderRadius:
                                                                                                        '10px',
                                                                                                    backgroundColor:
                                                                                                        '#FFFF',
                                                                                                    '&:hover':
                                                                                                        {
                                                                                                            backgroundColor:
                                                                                                                '#fff',
                                                                                                        },
                                                                                                    boxShadow:
                                                                                                        ' 0px 1px 20px 0px #8D1F241A',
                                                                                                }}
                                                                                            >
                                                                                                <ExpandMoreIcon
                                                                                                    style={{
                                                                                                        color: '#D12F37',
                                                                                                        fontSize:
                                                                                                            '30px',
                                                                                                    }}
                                                                                                />
                                                                                            </IconButton>
                                                                                        }
                                                                                    >
                                                                                        <Typography
                                                                                            sx={{
                                                                                                color: '#666666',
                                                                                            }}
                                                                                            style={{
                                                                                                minWidth:
                                                                                                    '100%',
                                                                                            }}
                                                                                            variant="HWZArtz"
                                                                                        >
                                                                                            {
                                                                                                modifier.modification_text
                                                                                            }
                                                                                        </Typography>
                                                                                    </AccordionSummary>
                                                                                    <AccordionDetails
                                                                                        sx={{
                                                                                            padding:
                                                                                                '0px',
                                                                                            width: '100%',
                                                                                        }}
                                                                                    >
                                                                                        {modifier
                                                                                            ?.options
                                                                                            ?.length >
                                                                                        0
                                                                                            ? modifier.options.map(
                                                                                                  (
                                                                                                      option: any,
                                                                                                      optionIndex: number
                                                                                                  ) => {
                                                                                                      return (
                                                                                                          <Grid
                                                                                                              key={
                                                                                                                  optionIndex
                                                                                                              }
                                                                                                              container
                                                                                                          >
                                                                                                              <Grid
                                                                                                                  item
                                                                                                                  lg={
                                                                                                                      10
                                                                                                                  }
                                                                                                                  md={
                                                                                                                      10
                                                                                                                  }
                                                                                                                  xs={
                                                                                                                      10
                                                                                                                  }
                                                                                                                  sx={{
                                                                                                                      display:
                                                                                                                          'flex',
                                                                                                                      justifyContent:
                                                                                                                          'flex-start',
                                                                                                                      alignItems:
                                                                                                                          'center',
                                                                                                                  }}
                                                                                                              >
                                                                                                                  {option?.option_image ? (
                                                                                                                      <Box
                                                                                                                          sx={{
                                                                                                                              width: '50px',
                                                                                                                              height: '50px',
                                                                                                                              aspectRatio:
                                                                                                                                  '1/1',
                                                                                                                              //backgroundImage: `linear-gradient(rgba(255, 236, 229,.8), rgba(255, 236, 229,.8)), url(${img_pattern_red})`,
                                                                                                                              backgroundRepeat:
                                                                                                                                  'repeat',
                                                                                                                              backgroundSize:
                                                                                                                                  '400px',
                                                                                                                              display:
                                                                                                                                  'flex',
                                                                                                                              alignItems:
                                                                                                                                  'center',
                                                                                                                              justifyContent:
                                                                                                                                  'center',
                                                                                                                              borderRadius:
                                                                                                                                  '10px',
                                                                                                                              borderColor:
                                                                                                                                  '#FFF',
                                                                                                                          }}
                                                                                                                      >
                                                                                                                          <img
                                                                                                                              src={
                                                                                                                                  option.option_image
                                                                                                                              }
                                                                                                                              style={{
                                                                                                                                  width: '80%',
                                                                                                                                  aspectRatio:
                                                                                                                                      '1/1',
                                                                                                                                  objectFit:
                                                                                                                                      'cover',
                                                                                                                              }}
                                                                                                                          />
                                                                                                                      </Box>
                                                                                                                  ) : (
                                                                                                                      ''
                                                                                                                  )}
                                                                                                                  <Typography
                                                                                                                      ml={
                                                                                                                          2
                                                                                                                      }
                                                                                                                      variant="InterMedium"
                                                                                                                  >
                                                                                                                      {`${
                                                                                                                          option?.option_name
                                                                                                                      }  ${
                                                                                                                          option?.option_price >
                                                                                                                          0
                                                                                                                              ? `($${(
                                                                                                                                    option?.option_price /
                                                                                                                                    100
                                                                                                                                ).toFixed(
                                                                                                                                    2
                                                                                                                                )})`
                                                                                                                              : ''
                                                                                                                      }`}
                                                                                                                  </Typography>
                                                                                                              </Grid>
                                                                                                              <Grid
                                                                                                                  item
                                                                                                                  lg={
                                                                                                                      2
                                                                                                                  }
                                                                                                                  md={
                                                                                                                      2
                                                                                                                  }
                                                                                                                  xs={
                                                                                                                      2
                                                                                                                  }
                                                                                                                  sx={{
                                                                                                                      display:
                                                                                                                          modifier?.group_by >
                                                                                                                          0
                                                                                                                              ? 'none'
                                                                                                                              : 'flex',
                                                                                                                      justifyContent:
                                                                                                                          'flex-end',
                                                                                                                      alignItems:
                                                                                                                          'center',
                                                                                                                  }}
                                                                                                              >
                                                                                                                  <IconButton
                                                                                                                      onClick={() => {
                                                                                                                          const isSelect =
                                                                                                                              option?.selected
                                                                                                                                  ? false
                                                                                                                                  : true;
                                                                                                                          //   const quantity =
                                                                                                                          //       option?.modifier_qyt !==
                                                                                                                          //       undefined
                                                                                                                          //           ? option?.modifier_qyt -
                                                                                                                          //             modifier?.group_by
                                                                                                                          //           : 0;
                                                                                                                          selectOptions(
                                                                                                                              i,
                                                                                                                              optionIndex,
                                                                                                                              isSelect
                                                                                                                          );
                                                                                                                      }}
                                                                                                                  >
                                                                                                                      {option?.selected ? (
                                                                                                                          <RadioButtonCheckedIcon
                                                                                                                              style={{
                                                                                                                                  color: '#D12F37',
                                                                                                                              }}
                                                                                                                          />
                                                                                                                      ) : (
                                                                                                                          <RadioButtonUncheckedIcon
                                                                                                                              style={{
                                                                                                                                  color: '#BFBFBF',
                                                                                                                              }}
                                                                                                                          />
                                                                                                                      )}
                                                                                                                  </IconButton>
                                                                                                              </Grid>

                                                                                                              <Grid
                                                                                                                  item
                                                                                                                  xs={
                                                                                                                      12
                                                                                                                  }
                                                                                                                  lg={
                                                                                                                      2
                                                                                                                  }
                                                                                                                  sx={{
                                                                                                                      justifyContent:
                                                                                                                          'flex-end',
                                                                                                                      display:
                                                                                                                          modifier?.group_by >
                                                                                                                          0
                                                                                                                              ? 'flex'
                                                                                                                              : 'none',
                                                                                                                      alignItems:
                                                                                                                          'center',
                                                                                                                      marginBottom:
                                                                                                                          '0px',
                                                                                                                      [theme.breakpoints.down(
                                                                                                                          'md'
                                                                                                                      )]:
                                                                                                                          {
                                                                                                                              marginBottom:
                                                                                                                                  '10px',
                                                                                                                          },
                                                                                                                  }}
                                                                                                              >
                                                                                                                  <IconButton
                                                                                                                      onClick={() => {
                                                                                                                          const isSelect =
                                                                                                                              true;
                                                                                                                          const quantity =
                                                                                                                              option?.modifier_qyt !==
                                                                                                                              undefined
                                                                                                                                  ? option?.modifier_qyt -
                                                                                                                                    modifier?.group_by
                                                                                                                                  : 0;
                                                                                                                          selectOptions(
                                                                                                                              i,
                                                                                                                              optionIndex,
                                                                                                                              isSelect,
                                                                                                                              quantity
                                                                                                                          );
                                                                                                                      }}
                                                                                                                      sx={{
                                                                                                                          width: '35px',
                                                                                                                          height: '35px',
                                                                                                                          borderRadius:
                                                                                                                              '10px',
                                                                                                                          backgroundColor:
                                                                                                                              '#FFF',
                                                                                                                          boxShadow:
                                                                                                                              '0px 8px 30px rgba(141, 31, 36, 0.12)',
                                                                                                                          '&:hover':
                                                                                                                              {
                                                                                                                                  backgroundColor:
                                                                                                                                      '#fff',
                                                                                                                              },
                                                                                                                      }}
                                                                                                                      aria-label="save"
                                                                                                                  >
                                                                                                                      <RemoveRoundedIcon
                                                                                                                          style={{
                                                                                                                              color: '#D12F37',
                                                                                                                              fontSize:
                                                                                                                                  '30px',
                                                                                                                          }}
                                                                                                                      />
                                                                                                                  </IconButton>
                                                                                                                  <Typography
                                                                                                                      variant="HWZArtz"
                                                                                                                      sx={{
                                                                                                                          fontSize:
                                                                                                                              '15px',
                                                                                                                          margin: '0px 20px',
                                                                                                                      }}
                                                                                                                  >
                                                                                                                      {option?.modifier_qyt !==
                                                                                                                      undefined
                                                                                                                          ? option?.modifier_qyt
                                                                                                                          : 0}
                                                                                                                  </Typography>
                                                                                                                  <IconButton
                                                                                                                      onClick={() => {
                                                                                                                          const isSelect =
                                                                                                                              true;
                                                                                                                          const quantity =
                                                                                                                              option?.modifier_qyt !==
                                                                                                                              undefined
                                                                                                                                  ? option?.modifier_qyt +
                                                                                                                                    modifier?.group_by
                                                                                                                                  : modifier?.group_by;
                                                                                                                          selectOptions(
                                                                                                                              i,
                                                                                                                              optionIndex,
                                                                                                                              isSelect,
                                                                                                                              quantity
                                                                                                                          );
                                                                                                                      }}
                                                                                                                      sx={{
                                                                                                                          width: '35px',
                                                                                                                          height: '35px',
                                                                                                                          borderRadius:
                                                                                                                              '10px',
                                                                                                                          backgroundColor:
                                                                                                                              '#FFF',
                                                                                                                          boxShadow:
                                                                                                                              '0px 8px 30px rgba(141, 31, 36, 0.12)',
                                                                                                                          '&:hover':
                                                                                                                              {
                                                                                                                                  backgroundColor:
                                                                                                                                      '#fff',
                                                                                                                              },
                                                                                                                      }}
                                                                                                                      aria-label="save"
                                                                                                                  >
                                                                                                                      <AddRoundedIcon
                                                                                                                          style={{
                                                                                                                              color: '#D12F37',
                                                                                                                              fontSize:
                                                                                                                                  '30px',
                                                                                                                          }}
                                                                                                                      />
                                                                                                                  </IconButton>
                                                                                                              </Grid>
                                                                                                          </Grid>
                                                                                                      );
                                                                                                  }
                                                                                              )
                                                                                            : null}
                                                                                    </AccordionDetails>
                                                                                </Accordion>
                                                                            </Grid>
                                                                        );
                                                                    }
                                                                )}
                                                            </Grid>
                                                        </Box>
                                                    </Stack>
                                                </div>
                                                <Divider
                                                    sx={{
                                                        border: '1px dashed #D9D9D9',
                                                    }}
                                                    variant="fullWidth"
                                                />
                                                {/* <>
                                                <div className="options-avail d-flex justify-content-between mt-2">
                                                    <h5>Optional</h5>
                                                    <div className="options-check">
                                                        <div className="checkboxes d-flex">
                                                            <div
                                                                className="all-bx"
                                                                style={{ paddingLeft: '10px' }}
                                                            >
                                                                <label className="checkbox">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="Instructions"
                                                                        name="Special Instructions"
                                                                        defaultChecked={
                                                                            instructions
                                                                        }
                                                                        onChange={(e) =>
                                                                            setInstructions(
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                    />
                                                                    <span>
                                                                        Special Instructions
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {instructions ? (
                                                    <div className="row">
                                                        <div className="col-12 col-md-6">
                                                            <label className="control-label">
                                                                Your Instructions
                                                            </label>
                                                            <div className="form-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="street"
                                                                    placeholder="Please, wrap in red paper"
                                                                    onChange={(e) =>
                                                                        setSelectedProduct({
                                                                            ...selectedProduct,
                                                                            menu_item_instructions:
                                                                                e.target.value,
                                                                        })
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                        ) : null}
                                                        </> */}
                                            </div>
                                        ) : products.length === 0 ? (
                                            <h2>No products avialable</h2>
                                        ) : (
                                            filteredProducts?.map((product) => (
                                                <div
                                                    className="col-12 col-md-4"
                                                    key={product?.id}
                                                    onClick={(e) => handleSelected(product)}
                                                >
                                                    <div className="card">
                                                        <a href="#">
                                                            <img
                                                                className="card-img-top"
                                                                alt="cookie"
                                                                src={product.product_image}
                                                                onError={handleOnError}
                                                            />
                                                        </a>
                                                        <div className="card-body">
                                                            <p className="card-text price">
                                                                ${(product?.price / 100).toFixed(2)}
                                                            </p>
                                                            <h5
                                                                className="card-title"
                                                                style={{
                                                                    color: '#111111',
                                                                    fontWeight: '600',
                                                                    fontSize: '16px',
                                                                }}
                                                            >
                                                                {product?.product_name}
                                                            </h5>
                                                            <p
                                                                className="card-text"
                                                                style={{
                                                                    color: 'rgba(17, 17, 17, 0.48)',
                                                                    fontSize: '14px',
                                                                }}
                                                            >
                                                                {product?.product_description}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 order-col-rgt">
                        <div className="info-header location-edit">
                            <div className="left-info">
                                <p className="d-flex">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={svgPaths['Orders'].width}
                                        height={svgPaths['Orders'].height}
                                        viewBox={svgPaths['Orders'].viewBox}
                                        fill="none"
                                    >
                                        <path d={svgPaths['Orders'].path} fill="#526EFF" />
                                    </svg>
                                    <strong>Order</strong>
                                </p>
                            </div>
                        </div>

                        {isAddToCartLoading ? (
                            <div className="h-48 w-[100] flex justify-center items-center">
                                <Spinner size="lg" />
                            </div>
                        ) : cartList.length > 0 ? (
                            <>
                                {cartList?.map(
                                    ({
                                        id,
                                        product_name,
                                        price,
                                        menu_item_instructions,
                                        menu_item_quantity,
                                        product_image,
                                        modifiers,
                                    }) => (
                                        <div className="new-products-list" key={id}>
                                            <div className="row">
                                                <div className="col-12 col-md-8">
                                                    <div className="new-ordr d-flex align-items-center">
                                                        <div className="ordr-icn">
                                                            <img
                                                                src={product_image}
                                                                alt="pImg"
                                                                onError={handleOnError}
                                                            />
                                                        </div>
                                                        <div className="order-details">
                                                            <p className="mb-0">
                                                                <strong>{product_name}</strong>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4">
                                                    <div className="order-quantity d-flex justify-content-between align-items-center h-100">
                                                        <div className="flex flex-col">
                                                            <strong>
                                                                $
                                                                {(
                                                                    (price * menu_item_quantity) /
                                                                    100
                                                                ).toFixed(2)}
                                                            </strong>
                                                            <p className="mb-0 flex">
                                                                {menu_item_quantity} x $
                                                                {(price / 100).toFixed(2)}
                                                            </p>
                                                        </div>
                                                        <a
                                                            onClick={() => removeProduct(id)}
                                                            href="#"
                                                        >
                                                            <Delete />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                {modifiers
                                                    ? modifiers?.map(
                                                          (modifier: any, idx: number) => {
                                                              return (
                                                                  <div key={idx}>
                                                                      {modifier?.options?.some(
                                                                          (el: any) => el?.selected
                                                                      ) ? (
                                                                          <strong className="mt-[5px]">
                                                                              {
                                                                                  modifier?.modification_text
                                                                              }
                                                                          </strong>
                                                                      ) : null}
                                                                      <div>
                                                                          {modifier?.options
                                                                              ?.length > 0
                                                                              ? modifier?.options?.map(
                                                                                    (
                                                                                        option: any,
                                                                                        optionInd: number
                                                                                    ) => {
                                                                                        return (
                                                                                            <React.Fragment
                                                                                                key={
                                                                                                    optionInd
                                                                                                }
                                                                                            >
                                                                                                {option?.selected ? (
                                                                                                    <div>
                                                                                                        {
                                                                                                            option?.option_name
                                                                                                        }{' '}
                                                                                                        {option?.option_price
                                                                                                            ? `-$${(
                                                                                                                  option?.option_price /
                                                                                                                  100
                                                                                                              ).toFixed(
                                                                                                                  2
                                                                                                              )}`
                                                                                                            : ''}
                                                                                                    </div>
                                                                                                ) : null}
                                                                                            </React.Fragment>
                                                                                        );
                                                                                    }
                                                                                )
                                                                              : null}
                                                                      </div>
                                                                  </div>
                                                              );
                                                          }
                                                      )
                                                    : null}
                                            </div>
                                            {menu_item_instructions ? (
                                                <p className="instructions f-14 pt-2">
                                                    <InfoOutlined className="pColor" /> Special
                                                    instructions:
                                                    <strong>{menu_item_instructions}</strong>
                                                </p>
                                            ) : null}
                                        </div>
                                    )
                                )}
                                <div className="checkboxes pt-3">
                                    <div className="all-bx">
                                        <label className="checkbox">
                                            <input
                                                onChange={(e) => {
                                                    setIsDiscount(e?.target?.checked);
                                                    setPromoCode('');
                                                    setPromoCodeResponse({
                                                        message: '',
                                                        data: {},
                                                    });
                                                }}
                                                type="checkbox"
                                                id="reward"
                                                name="reward"
                                                value="reward"
                                            />
                                            <span> Add discount</span>
                                        </label>
                                    </div>
                                </div>
                                {isDiscount ? (
                                    <div>
                                        <div>Add promo code</div>
                                        <div className="flex w-full " style={{ marginTop: '5px' }}>
                                            <input
                                                style={{ marginBottom: '5px' }}
                                                value={promoCode}
                                                onChange={(e) => {
                                                    setPromoCode(e?.target?.value);
                                                    if (promoCodeResponse !== '')
                                                        setPromoCodeResponse({
                                                            message: '',
                                                            data: {},
                                                        });
                                                }}
                                                placeholder="Promo Code"
                                                type="text"
                                            />
                                            <Button
                                                disabled={
                                                    !promoCode || promoCodeResponse?.data?.valid
                                                }
                                                onClick={() => handlePromoCodeSubmit()}
                                                style={{ height: '40px', marginLeft: '10px' }}
                                            >
                                                {promoCodeResponse?.data?.valid
                                                    ? 'Applied'
                                                    : 'Apply'}
                                            </Button>
                                        </div>
                                        <div
                                            className="mb-[5px] font-semibold text-sm"
                                            style={{
                                                color: promoCodeResponse?.data?.valid
                                                    ? 'green'
                                                    : 'red',
                                            }}
                                        >
                                            {promoCodeResponse?.message}
                                        </div>
                                    </div>
                                ) : null}
                                <ul className="instruction-listing">
                                    {/*<li>
                                        <span style={{ display: 'flex', gap: '0.3rem' }}>
                                            <img src={loyaltyIcon} /> Points
                                        </span>
                                        <span className="dark-tx"></span>
                                    </li>*/}
                                    <li>
                                        <span> Sub-total</span>
                                        <span className="dark-tx">
                                            $ {getSubTotal()}
                                            {/* {(
                                                cartList?.reduce(
                                                    (acc, curr: any) =>
                                                        acc +
                                                        curr?.price +
                                                        (curr?.modifiers
                                                            ? curr?.modifiers?.reduce(
                                                                  (modAcc: any, modCurr: any) =>
                                                                      modAcc +
                                                                      modCurr?.options?.reduce(
                                                                          (
                                                                              optAcc: any,
                                                                              optCurr: any
                                                                          ) =>
                                                                              optAcc +
                                                                              optCurr?.option_price
                                                                                  ? optCurr?.option_price
                                                                                  : 0,
                                                                          0
                                                                      ),
                                                                  0
                                                              )
                                                            : 0) *
                                                            curr?.menu_item_quantity,
                                                    0
                                                ) / 100
                                            ).toFixed(2)} */}
                                        </span>
                                    </li>
                                    {isOrder.order_type_id === '17' ? null : (
                                        <li>
                                            <span> Delivery fee</span>
                                            <span className="dark-tx">
                                                $
                                                {cartCharges?.delivery_fee
                                                    ? (cartCharges?.delivery_fee / 100).toFixed(2)
                                                    : 0}
                                            </span>
                                        </li>
                                    )}
                                    <li>
                                        <span> Tax Rate {`(${cartCharges?.tax}%)`}</span>
                                        <span className="dark-tx">
                                            ${getTaxAmount()}
                                            {/* {cartCharges?.tax}% */}
                                        </span>
                                    </li>
                                    {promoCodeResponse?.data?.valid ? (
                                        <li>
                                            <span> Discount</span>
                                            <span className="dark-tx">
                                                {(promoCodeResponse?.data?.discount / 100).toFixed(
                                                    2
                                                )}
                                            </span>
                                        </li>
                                    ) : null}
                                    <li>
                                        <strong>Total</strong>
                                        <span className="dark-tx">
                                            <strong>
                                                $ {getFinalPrice()}
                                                {/* {(
                                                    (cartList?.reduce(
                                                        (acc, curr) => acc + curr?.price,
                                                        0
                                                    ) +
                                                        Number(
                                                            promoCodeResponse?.data?.valid
                                                                ? promoCodeResponse?.data?.discount
                                                                : -0
                                                        )) /
                                                        100 +
                                                    cartCharges?.delivery_fee / 100 +
                                                    (cartList?.reduce(
                                                        (acc, curr) => acc + curr?.price,
                                                        0
                                                    ) *
                                                        cartCharges?.tax) /
                                                        100 /
                                                        100
                                                ).toFixed(2)} */}
                                            </strong>
                                        </span>
                                    </li>
                                </ul>
                                {/* <div className="row timer-row flex align-items-center">
                                    <div className="col-12 col-md-6">
                                        <div className="time-wrap">
                                            <h6>
                                                <AccessTimeOutlined className="pColor" />
                                                Promised Time
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            <select
                                                className="form-control"
                                                name="status"
                                                required
                                                onChange={(e) => setPromiseTime(e.target.value)}
                                            >
                                                <option value="">Select or Type</option>
                                                {timeSlots?.map((value: string) => (
                                                    <option key={value} value={value}>
                                                        {value}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div> */}
                                {/* <hr className="" /> */}
                                <div className="instuct-btn mt-3">
                                    <button
                                        type="button"
                                        className="btn add-icon-btn flex justify-center"
                                        onClick={() =>
                                            selectedUserAction({
                                                action: 'add-invoice',
                                                data: {
                                                    ...userData,
                                                    ...cartCharges,
                                                    promiseTime,
                                                    price: getFinalPrice(),
                                                    cartId,
                                                    ...isOrder,
                                                    // promiseTime: `${
                                                    //     new Date().toISOString().split('T')[0]
                                                    // } ${promiseTime}`,
                                                },
                                            })
                                        }
                                        disabled={!promiseTime}
                                    >
                                        <img src={invoiceIcon} alt="invoice" /> Send Invoice
                                    </button>
                                </div>
                            </>
                        ) : (
                            <div className="col-12 col-md-4 w-full">
                                <div className="new-products">
                                    <div className="pr-icon">
                                        <svg
                                            width="19"
                                            height="22"
                                            viewBox="0 0 19 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M1.5 22H17.5C17.7652 22 18.0196 21.8946 18.2071 21.7071C18.3946 21.5196 18.5 21.2652 18.5 21V5C18.5 4.73478 18.3946 4.48043 18.2071 4.29289C18.0196 4.10536 17.7652 4 17.5 4H1.5C1.23478 4 0.98043 4.10536 0.792893 4.29289C0.605357 4.48043 0.5 4.73478 0.5 5V21C0.5 21.2652 0.605357 21.5196 0.792893 21.7071C0.98043 21.8946 1.23478 22 1.5 22ZM2.5 6H16.5V20H2.5V6ZM15.5 0C15.7652 0 16.0196 0.105357 16.2071 0.292893C16.3946 0.48043 16.5 0.734784 16.5 1C16.5 1.26522 16.3946 1.51957 16.2071 1.70711C16.0196 1.89464 15.7652 2 15.5 2H3.5C3.23478 2 2.98043 1.89464 2.79289 1.70711C2.60536 1.51957 2.5 1.26522 2.5 1C2.5 0.734784 2.60536 0.48043 2.79289 0.292893C2.98043 0.105357 3.23478 0 3.5 0H15.5ZM13.5 9V11C13.5 11.2652 13.3946 11.5196 13.2071 11.7071C13.0196 11.8946 12.7652 12 12.5 12H6.5C6.23478 12 5.98043 11.8946 5.79289 11.7071C5.60536 11.5196 5.5 11.2652 5.5 11V9C5.5 8.73478 5.60536 8.48043 5.79289 8.29289C5.98043 8.10536 6.23478 8 6.5 8C6.76522 8 7.01957 8.10536 7.20711 8.29289C7.39464 8.48043 7.5 8.73478 7.5 9V10H11.5V9C11.5 8.73478 11.6054 8.48043 11.7929 8.29289C11.9804 8.10536 12.2348 8 12.5 8C12.7652 8 13.0196 8.10536 13.2071 8.29289C13.3946 8.48043 13.5 8.73478 13.5 9Z"
                                                fill="#A3BED9"
                                            />
                                        </svg>
                                    </div>
                                    <h5 className="text-center font-bold">There are no products</h5>
                                    <p className="text-center">
                                        You currently do not have any items. Please add items to
                                        your order
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewOrder1;
